var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5501 9.47574C15.5501 8.66018 15.1523 8.00018 14.6645 8.00018C14.1756 8.00018 13.779 8.66018 13.779 9.47574C13.779 10.2902 14.1756 10.9513 14.6645 10.9513C15.1523 10.9513 15.5501 10.2913 15.5501 9.47574ZM10.2379 9.47574C10.2379 8.66018 9.84008 8.00018 9.3523 8.00018C8.8623 8.00018 8.46675 8.66018 8.46675 9.47574C8.46675 10.2902 8.8623 10.9513 9.3523 10.9513C9.84008 10.9513 10.2379 10.2913 10.2379 9.47574ZM15.9747 14.389C15.6908 14.1545 15.2706 14.1945 15.0361 14.4783C14.2994 15.3699 13.3081 15.8107 12.0089 15.8107C10.7087 15.8107 9.71737 15.37 8.98061 14.4783C8.74609 14.1945 8.32588 14.1545 8.04204 14.389C7.75821 14.6236 7.71823 15.0438 7.95276 15.3276C8.94989 16.5344 10.3212 17.1441 12.0089 17.1441C13.6957 17.1441 15.0669 16.5343 16.0639 15.3276C16.2985 15.0438 16.2585 14.6236 15.9747 14.389Z",
    fill: "#081B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5002C16.6944 20.5002 20.5 16.6946 20.5 12.0002C20.5 7.30576 16.6944 3.50018 12 3.50018C7.30558 3.50018 3.5 7.30576 3.5 12.0002C3.5 16.6946 7.30558 20.5002 12 20.5002ZM12 22.0002C17.5228 22.0002 22 17.523 22 12.0002C22 6.47734 17.5228 2.00018 12 2.00018C6.47715 2.00018 2 6.47734 2 12.0002C2 17.523 6.47715 22.0002 12 22.0002Z",
    fill: "#081B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/Emoji.2c974f1137a8a89f0603097aeec7d2f6.svg";
export { ForwardRef as ReactComponent };